import { queryOptions } from '@tanstack/react-query';
import { getListings, type ListingsQueryParams } from '@/actions/listings';
import { getAllPages } from '@/utils/fetch/pagination';

const RESOURCE = 'listings' as const;

const listings = {
  byParams: (params: ListingsQueryParams) =>
    queryOptions({
      queryFn: () => getAllPages(getListings, params),
      queryKey: [RESOURCE, 'byParams', params] as const,
    }),
};

export { listings, RESOURCE as LISTINGS_QUERY_KEY };
